import { IconProps } from "./types";

export default function ClapboardIcon({ className }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.602 2.5918H6.24918C6.24918 2.5918 6.19771 2.5918 6.16683 2.5918C6.15654 2.5918 6.13595 2.5918 6.12565 2.5918C4.05655 2.65709 2.38892 4.45261 2.38892 6.66165V17.5436C2.38892 19.7962 4.11832 21.6243 6.24918 21.6243H18.602C20.7329 21.6243 22.4623 19.7962 22.4623 17.5436V6.67253C22.4623 4.41997 20.7329 2.5918 18.602 2.5918ZM20.9182 6.67253V8.03278H20.0638L17.902 4.22409H18.5917C19.8682 4.22409 20.9079 5.32317 20.9079 6.67253H20.9182ZM9.76975 8.03278L7.608 4.22409H10.9536L13.1153 8.03278H9.76975ZM14.9168 8.03278L12.755 4.22409H16.1006L18.2623 8.03278H14.9168ZM3.93302 6.67253C3.93302 5.47552 4.75655 4.47438 5.83742 4.26762L7.97858 8.03278H3.94332V6.67253H3.93302ZM20.9182 17.5545C20.9182 18.9039 19.8785 20.0029 18.602 20.0029H6.24918C4.97272 20.0029 3.93302 18.9039 3.93302 17.5545V9.66507H20.9182V17.5545Z"
        strokeWidth="inherit"
        fill="currentColor"
      />
    </svg>
  );
}
